/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from "axios";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import useStyles from './style';
import StepIcon from 'components/StepIcon';
import Back from 'assets/svg/back';
import PaymentMethod from 'components/PaymentMethod';
import { Button } from '@chakra-ui/react';
import Close from 'assets/svg/close';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#8C9197',
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1A7431',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1A7431',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const steps = ['Confirm Order', 'Payment'];


const Payment = (props) => {
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [service, setService] = useState([]);
  const styles = useStyles();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (props?.match?.params?.userId && props?.match?.params?.type) {
      axios.get(`https://api.personatalenta.id/user/${props?.match?.params?.type}/${props.match.params.userId}`, { headers: { Authorization: `Bearer ${token ? token : ''}`, "Content-Type": "x-www-from-urlencode", 'Access-Control-Allow-Origin': 'http://localhost:3000', 'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept' } })
        .then(res => {
          setUser(res.data.user ?? res.data.colleagues)
        }).catch(err => {
          if (err.response?.data?.message === "Unauthorized" || err.response?.data === "Unauthorized") {
            // navigate('/');
          }
        })
    } else {
      let localUser = localStorage.getItem('user');
      if (localUser) {
        setUser(JSON.parse(localUser))
      } else {
        window.location.assign('/home')
      }
    }
    if (token) {
      axios.get(`https://api.personatalenta.id/product/list/${props?.match?.params?.productId}`, { headers: { Authorization: `Bearer ${token ? token : ''}`, "Content-Type": "x-www-from-urlencode" } })
        .then(res => {
          setService(res.data.products)
        }).catch(err => {
          if (err.response.data.message === "Unauthorized" || err.response.data === "Unauthorized") {
            // navigate('/');
          }
        })
    } else {
      // navigate('/')
    }
  }, []);

  return (
    <div className={styles.app}>
      <div className={styles.services}>
        <div className={styles.containerContent}>
          {/* <div className={styles.stepperContainer}>
            <div onClick={activeStep === 0 ? () => window.history.go(-1) : () => setActiveStep(activeStep - 1)} className={styles.backButton}>
              <Back />
            </div>
            <div className="step">
              <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </div>
          </div> */}
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className={styles.containerStepTwo}>
                <div className={activeStep === 0 ? styles.containerTopBack : styles.containerTopBackInvoice}>
                  {activeStep === 0 ? (
                    <>
                      <div className={styles.containerTopTwo}>
                        <h4 className="title">Draft invoice</h4>
                        <p className="content">Please check again the data you provided below and service you want to order. </p>
                      </div>
                      <div onClick={activeStep === 0 ? () => window.history.go(-1) : () => setActiveStep(activeStep - 1)} className={styles.backButton}>
                        <Close />
                      </div>
                    </>
                  ) : (
                    <div className={styles.containerTopInvoiceTwo}>
                      <h4 className="title">invoice</h4>
                    </div>
                  )}
                </div>
                <div className={styles.containerCenter}>
                  <div className={styles.containerLeft}>
                    <div className={styles.containerOrder}>
                      <h6 className="title">Name</h6>
                      <p className="content">{user.name}</p>
                    </div>
                    <div className={styles.containerOrder}>
                      <h6 className="title">Gender</h6>
                      <p className="content">{user.gender === 0 ? "Male" : "Female"}</p>
                    </div>
                    <div className={styles.containerOrder}>
                      <h6 className="title">Service Type</h6>
                      <p className="content">{service?.name}</p>
                    </div>
                  </div>
                  <div className={styles.containerLeft}>
                    <div className={styles.containerOrder}>
                      <h6 className="title">Total Price</h6>
                      <div>
                        <p className="content">Rp {new Intl.NumberFormat('id-ID').format(service?.price)}</p>
                        {activeStep === 0 && (
                          <Button
                            borderWidth={1}
                            borderColor="#1A7431"
                            bgColor="#1A7431"
                            color='#fff'
                            fontSize='sm'
                            w="100%"
                            fontWeight='bold'
                            borderRadius='5px'
                            px='10px'
                            py='10px'
                            onClick={() => setActiveStep(activeStep + 1)}
                          >
                            {"Lanjutkan pembayaran"}
                          </Button>
                        )}
                      </div>
                    </div>
                    {activeStep === 1 && (
                      <div className={styles.containerOrder}>
                        <h6 className="title">Lakukan Pembayaran dengan Scan QRIS</h6>
                        <div>
                          <PaymentMethod productId={service?.id} type={service?.type} user={user} isUser={props?.match?.params?.type !== 'colleague'} service={service.name} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

export default Payment;
